module.exports = "<span >{{label}}</span>\n"